import type { JobPost } from '@/generated/hey-api/types.gen';

type JobLike = Pick<JobPost, 'designation' | 'company_name'>;

export function jobFromMatches(
	matches: ReadonlyArray<{ loaderData?: unknown }>,
): JobLike | undefined {
	for (const m of matches) {
		const data = m.loaderData;
		if (
			data &&
			typeof data === 'object' &&
			'job' in data &&
			data.job &&
			typeof data.job === 'object'
		) {
			return data.job as JobLike;
		}
	}
	return undefined;
}

export function jobTitle(job: JobLike | undefined, section?: string): string {
	if (!job) return section ? `${section} | Flexiple` : 'Flexiple';
	const designation = job.designation ?? 'Job';
	const base = job.company_name ? `${job.company_name}: ${designation}` : designation;
	return section ? `${base} - ${section} | Flexiple` : `${base} | Flexiple`;
}
